// extracted by mini-css-extract-plugin
module.exports = {"navitemactive":"NavItem_navitemactive__2QAbQ","naviteminactive":"NavItem_naviteminactive__2XDzG"};